import type { PContainer, PGraphics } from '../../../engine/aliases'
import { common } from '../../../main/common-sidecar'
import { chessColors } from '../chessColors-sidecar'

export function createGraphics(layer: PContainer) {
  let g = common.getPhaserScene().add.graphics()
  layer.add(g)
  return g
}

export function bevelArea(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number = 16,
  inset: number = 0,
) {
  x += inset
  y += inset
  w -= inset * 2
  h -= inset * 2
  // g.beginPath()
  // g.moveTo(x, y)
  // g.lineTo(x + w - bevel, y)
  // g.lineTo(x + w, y + bevel)
  // g.lineTo(x + w, y + h)
  // g.lineTo(x + bevel, y + h)
  // g.lineTo(x, y + h - bevel)
  // g.closePath()

  g.beginPath()
  g.moveTo(x, y)
  g.lineTo(x + w, y)
  g.lineTo(x + w, y + h)
  g.lineTo(x, y + h)
  g.closePath()
}

export function bevelAreaR(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number,
  inset: number = 0,
) {
  x += inset
  y += inset
  w -= inset * 2
  h -= inset * 2
  g.beginPath()
  g.moveTo(x, y + bevel)
  g.lineTo(x + bevel, y)

  g.lineTo(x + w, y)

  g.lineTo(x + w, y + h - bevel)
  g.lineTo(x + w - bevel, y + h)
  g.lineTo(x, y + h)

  g.closePath()
}

export function bevelPanel(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number = 16,
  inset: number = 10,
) {
  bevelPanelBackground(g, x, y, w, h, bevel, inset)
  bevelPanelOutline(g, x, y, w, h, bevel, inset)
}

export function bevelPanelBackground(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number = 16,
  inset: number = 10,
) {
  g.fillStyle(chessColors.g3, 1)

  bevelArea(g, x, y, w, h, bevel)
  g.fill()
}

export function bevelPanelOutline(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number = 16,
  inset: number = 10,
) {
  g.lineStyle(6, chessColors.purple)
  bevelArea(g, x, y, w, h, bevel, inset)
  g.stroke()
}

export function bevelPanel2(
  g: PGraphics,
  x: number,
  y: number,
  w: number,
  h: number,
  bevel: number = 16,
  inset: number = 10,
) {
  g.fillStyle(chessColors.g3, 1)
  bevelArea(g, x, y, w, h, bevel)
  g.fill()
  g.fillStyle(chessColors.purpleDull, 1)
  bevelArea(g, x, y, w, h, bevel, 6)
  g.fill()
}
